<div class="card-header">
  <app-breadcrumb currentPage="mijn e-mailadres aanpassen"></app-breadcrumb>
</div>

<div class="card-body">

  <div>
    <form *ngIf="!emailValid" class="form" (ngSubmit)="submitEmail(emailForm.value)" [formGroup]="emailForm">
      <h2>Voer een nieuw e-mailadres in</h2>
      <div [ngClass]="{ 'input-error': emailSubmitted && emailForm.controls.username.errors || emailError }">
        <label for="username" class="form-label">{{'email_address' | translate}}</label>
        <input formControlName="username" id="username" type="text">
        <div class="errors">
          <div *ngIf="emailForm.controls.username.errors?.required">{{ 'email_address.required' | translate }}</div>
          <div *ngIf="emailForm.controls.username.errors?.pattern">{{ 'email_address.invalid' | translate }}</div>
          {{ emailError }}
        </div>
      </div>
      <div class="spacer"></div>
      <div>
        <button type="button" routerLink="/" class="btn btn-left arrow-left">annuleer</button>
        <button class="btn inverted accent plus">wijzigen</button>
      </div>
    </form>
    <div *ngIf="emailValid">
      <h2>voer de bevestigingscode in</h2>
      <p>
        U heeft een bevestigings-e-mail ontvangen. Kopieer-plak de activatie-code in het onderstaande veld. <br>
        Heeft u geen bevestigings-e-mail ontvangen? Controleer dan de spambox of
        <span (click)="resend()" class="link">verstuur de bevestigings-e-mail opnieuw.</span>
      </p>
      <form class="form">
        <div [ngClass]="{ 'input-error': codeError }">
          <label for="confirmationCode" class="form-label">bevestigingscode</label>
          <input name="confirmationCode" id="confirmationCode" type="text" (ngModelChange)="codeChanged($event)"
                 [(ngModel)]="code">
          <div class="errors">
            {{ codeError }}
          </div>
        </div>
        <div class="spacer"></div>
        <button type="button" class="btn btn-left arrow-left" (click)="emailValid = false">terug</button>
      </form>
    </div>
  </div>
</div>
